import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import TicketTableReportPDF from '../../../components/Reports/TicketReport/TicketTableReportPDF';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core';
import { useUnitDescription } from '../../../../providers/UnitDescriptionContext';
import { useCustomer } from '../../../../providers/CustomerContext';
import { useUser } from '../../../../providers/UserContext';

const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        width: '100%',
        padding: '32px',
        justifyContent: 'center',
        marginTop: '40px',
    },
}));

function TicketTableReportPrint(props) {
    const classes = useStyles();
    const { getUnitsPromise } = useUnitDescription();
    const { getCustomersPromise } = useCustomer();
    const { getUsersPromise } = useUser();

    const [loading, setLoading] = useState(true);
    const [sortedData, setSortedData] = useState({})

    useEffect(() => {
        Promise.all([getUnitsPromise(), getCustomersPromise(), getUsersPromise()]).then((res) =>{
            const units = res[0]
            const customers = res[1]
            const users = res[2]
            let sortedValue = []

            for(let document of props.location.state.data){
                document.unitsDisplay = document.units?.map((unit) => { return units.find(x=> x.docId === unit).unitNumber })
                document.customerDisplay = customers.find(x=> x.docId === document.customerId).name
                document.userDisplay = users.find(x=> x.uuid === document.uid).displayName

                sortedValue = {...sortedValue, [document.uid]: [...sortedValue[document.uid] || [], document]}
            }
            setSortedData(sortedValue)
            setLoading(false)
        })
    //eslint-disable-next-line
    }, [props.location.state]);
    
    return (
        loading
            ? 
            <div className={classes.content}>
                <Skeleton variant='rect' width={'63vw'} height={'80vh'} />
            </div>
            : 
            <TicketTableReportPDF
                sortedData={sortedData} 
                startDate={props.location.state.startDate}
                endDate={props.location.state.endDate}
            />
    )
}

export default withRouter(TicketTableReportPrint)